import React, { useState } from 'react';
import { shopAPI } from '../../utils/api';
import '../../assets/Shops.css';
import '../../App.css';

export const AddByPhone: React.FC<{ onAdd: () => void }> = ({ onAdd }) => {
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await shopAPI.onboardByPhone({ phone });
      onAdd();
    } catch (err: any) {
      setError(err.message || 'Error onboarding shop');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-card">
      <div className="form-card__head">
        <h2 className="form-card__title">Invite by phone</h2>
        <p className="form-card__sub">
          We’ll message this number on WhatsApp and ask for the shop’s name,
          product type, CR number and location.
        </p>
      </div>

      <form className="modal-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label" htmlFor="shop-phone">Shop phone</label>
          <input
            id="shop-phone"
            className="form-input"
            type="tel"
            placeholder="+974 3312 4455"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            required
          />
          <span className="form-help">Include the country code.</span>
        </div>

        {error && <div className="banner banner--danger">{error}</div>}

        <button type="submit" className="btn btn--primary btn--block" disabled={loading}>
          {loading ? 'Sending…' : 'Send invite'}
        </button>
      </form>
    </div>
  );
};
